function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { DateTime, Duration } from 'luxon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faDirections } from '@fortawesome/free-solid-svg-icons';
import { uuid } from 'uuidv4';
import { isAndroid } from 'react-device-detect';
import './RaceRow.css';

var RaceList = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(RaceList, _React$PureComponent);

  function RaceList(props) {
    var _this;

    _classCallCheck(this, RaceList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RaceList).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "raceName", function () {
      var race = _this.props.race;
      var raceName = race.name;

      if (!raceName || raceName === '') {
        if (race.category === 'Practice') {
          raceName = race.category;
        } else {
          raceName = "".concat(race.region, " ").concat(race.category);
        }
      }

      return raceName;
    });

    _defineProperty(_assertThisInitialized(_this), "findTrack", function () {
      var _this$props = _this.props,
          tracks = _this$props.tracks,
          race = _this$props.race;
      return tracks.find(function (track) {
        return track.name === race.trackname;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addToNativeCalendar", function () {
      var _this$props2 = _this.props,
          tracks = _this$props2.tracks,
          race = _this$props2.race;

      var raceName = _this.raceName(race);

      var track = _this.findTrack();

      var description = track ? [track.name, track.email, track.website_url].filter(function (prop) {
        return !!prop;
      }).join(' ') : race.trackname;
      var calOptions = window.plugins.calendar.getCalendarOptions();
      calOptions.firstReminderMinutes = 60 * 12;
      window.plugins.calendar.createEventInteractivelyWithOptions(raceName, "".concat(track.position.lat, ",").concat(track.position.lng), description, race.begins_on.toJSDate(), race.begins_on.plus(Duration.fromMillis(86400000)).toJSDate(), calOptions, function () {}, function (error) {
        console.error(error);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addToCalendar", function () {
      if (window.cordova) {
        return _this.addToNativeCalendar();
      }

      var _this$props3 = _this.props,
          tracks = _this$props3.tracks,
          race = _this$props3.race;

      var raceName = _this.raceName();

      var track = _this.findTrack();

      var description = track ? [track.name, track.email, track.website_url].filter(function (prop) {
        return !!prop;
      }).join(' ') : race.trackname;
      var href = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'BEGIN:VEVENT', 'URL:' + document.URL, 'UID:' + uuid(), 'DTSTAMP:' + DateTime.fromJSDate(new Date()).toISO().replace(/-|:|\.\d+/g, '').split('T')[0], 'DTSTART:' + race.begins_on.toISO().replace(/-|:|\.\d+/g, '').split('T')[0], 'DTEND:' + race.ends_on.toISO().replace(/-|:|\.\d+/g, '').split('T')[0], 'SUMMARY:' + raceName, 'DESCRIPTION:' + description, 'LOCATION:' + "".concat(track.position.lat, ",").concat(track.position.lng), 'END:VEVENT', 'END:VCALENDAR'].join('\n');
      var blob = new Blob([href], {
        type: 'text/calendar'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "".concat(raceName, ".ics");
      link.click();
      link.remove();
    });

    _defineProperty(_assertThisInitialized(_this), "navigateTo", function () {
      var track = _this.findTrack();

      if (!track) {
        return;
      }

      if (window.cordova) {
        directions.navigateTo(track.position.lat, track.position.lng);
      } else {
        var link = document.createElement('a');
        link.href = "geo:".concat(track.position.lat, ",").concat(track.position.lng);
        link.click();
        link.remove();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "openEventUrl", function () {
      var race = _this.props.race;
      var url = "https://www.usabmx.com/site/bmx_races/".concat(race.id);

      if (window.cordova) {
        if (isAndroid) {
          cordova.InAppBrowser.open(url);
        } else {
          cordova.InAppBrowser.open(url, '_blank', {
            usewkwebview: 'yes'
          });
        }
      } else {
        window.open(url, '_system');
      }
    });

    return _this;
  }

  _createClass(RaceList, [{
    key: "mapRegion",
    value: function mapRegion(region) {
      switch (region) {
        case 'National':
          return 'NAT';

        case 'South West':
          return 'SW';

        case 'North Central':
          return 'NC';

        case 'South Central':
          return 'SC';

        case 'North West':
          return 'NW';

        case 'North East':
          return 'NE';

        case 'South East':
          return 'SE';

        default:
          return region;
      }
    }
  }, {
    key: "render",
    // <div className="time">{race.starttime.toLocaleString(DateTime.TIME_SIMPLE)}</div>
    value: function render() {
      var addToCalendar = this.addToCalendar,
          raceName = this.raceName,
          navigateTo = this.navigateTo,
          openEventUrl = this.openEventUrl;
      var _this$props4 = this.props,
          app = _this$props4.app,
          race = _this$props4.race;
      return React.createElement("div", {
        className: "race-row ".concat(race.category.replace(' ', ''), " ").concat(race.series.replace(' ', ''), " ").concat(window.cordova ? 'mobile' : '', " ").concat(isAndroid ? 'android' : ''),
        key: race.id.toString(),
        style: this.props.style
      }, React.createElement("div", {
        className: "identifier"
      }), React.createElement("div", {
        className: "content"
      }, React.createElement("div", {
        className: "region-container"
      }, React.createElement("div", {
        className: "region"
      }, this.mapRegion(race.region))), React.createElement("div", {
        className: "details"
      }, React.createElement("div", {
        className: "racename",
        onClick: openEventUrl
      }, raceName()), React.createElement("div", {
        className: "date-time"
      }, React.createElement("div", {
        className: "date"
      }, race.begins_on.toLocaleString(DateTime.DATE_FULL)), React.createElement("div", {
        className: "secondary"
      }, React.createElement("div", {
        className: "day"
      }, race.begins_on.toLocaleString({
        weekday: 'long'
      })))), React.createElement("div", {
        className: "trackname",
        onClick: function onClick(e) {
          return app.showTrackWithName(race.trackname);
        }
      }, race.trackname), React.createElement("div", {
        className: "location"
      }, "".concat(race.city, ", ").concat(race.state, ", ").concat(race.country))), React.createElement("div", {
        className: "get-directions",
        onClick: navigateTo
      }, React.createElement(FontAwesomeIcon, {
        icon: faDirections
      })), React.createElement("div", {
        className: "add-to-calendar",
        onClick: addToCalendar
      }, React.createElement(FontAwesomeIcon, {
        icon: faCalendar
      }))));
    }
  }]);

  return RaceList;
}(React.PureComponent);

export default RaceList;